/** Common starting point for pet policy annual limits (USD). */
export const PET_ANNUAL_LIMIT_RECOMMENDED = 5000;

export const PET_ANNUAL_LIMIT_MIN = 1000;
export const PET_ANNUAL_LIMIT_MAX = 100_000;

/** Typical upper bound for pet insurance deductibles (USD). */
export const PET_DEDUCTIBLE_MAX = 1000;

export const PET_QUOTE_DEFINITIONS = {
  annualLimit:
    'Annual limit - total reimbursements in that year can\u2019t exceed this cap.',
  reimbursement: 'Reimbursement - the insurer pays their percentage of what\u2019s left.',
  deductible: 'Deductible - you pay this first (until it\u2019s used up for the period).',
} as const;

export type PetAnnualLimitPayload = 'decide_later' | string;

export function parseAnnualLimitInput(raw: string): { value: PetAnnualLimitPayload; error?: string } {
  const digits = raw.replace(/\D/g, '');
  if (!digits) return { value: 'decide_later' };
  const n = Number(digits);
  if (!Number.isFinite(n) || n < PET_ANNUAL_LIMIT_MIN) {
    return {
      value: 'decide_later',
      error: `Enter an annual limit of at least $${PET_ANNUAL_LIMIT_MIN.toLocaleString()}, or leave blank.`,
    };
  }
  if (n > PET_ANNUAL_LIMIT_MAX) {
    return {
      value: 'decide_later',
      error: `Annual limit cannot exceed $${PET_ANNUAL_LIMIT_MAX.toLocaleString()}.`,
    };
  }
  return { value: String(n) };
}

export function parseDeductibleInput(raw: string): { value: number; error?: string } {
  const trimmed = raw.trim();
  if (!trimmed) return { value: 0 };
  const digits = trimmed.replace(/\D/g, '');
  if (!digits) return { value: 0, error: 'Enter a dollar amount or leave blank to decide later.' };
  const n = Number(digits);
  if (!Number.isFinite(n) || n < 0 || n > PET_DEDUCTIBLE_MAX) {
    return {
      value: 0,
      error: `Deductible must be between $0 and $${PET_DEDUCTIBLE_MAX.toLocaleString()}.`,
    };
  }
  return { value: n };
}
